import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const parcelsStyles = makeStyles((theme: Theme) =>
  createStyles({
    events: {
      marginBottom: 30,
      [theme.breakpoints.down("xs")]: {
        marginBottom: 40,
      },
    },
    root: {
      width: "100%",
      paddingTop: "16px",
      height: "88vh",
      overflow: "auto",
      overflowX: "hidden",
    },
    rightContent: {
      height: "100%",
      backgroundColor: "#fff",
      padding: "16px",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        height: "68vh",
      },
    },
    rightSubContent: {
      overflow: "scroll",
      overflowX: "hidden",
      scrollbarWidth: "thin",
      position: "relative",
      right: 5,
      zIndex: 1,
      top: 55,
      "&::-webkit-scrollbar": {
        display: "none",
      },
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    l1: {
      display: "flex",
      paddingTop: 10,
      top: 80,
      position: "fixed",
      overflowY: "hidden",
      overflowX: "hidden",
      zIndex: 1,
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        position: "inherit",
      },
    },
    l2: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingRight: 10,
      zIndex: 200,
      [theme.breakpoints.down("xs")]: {
        paddingTop: 0,
        zIndex: "inherit",
      },
    },
    l3: {
      paddingTop: 20,
      display: "flex",
      flexFlow: "wrap",
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        flexFlow: "nowrap",
        display: "flex",
        paddingTop: 0,
        paddingBottom: 20,
        width: "100%",
        zIndex: 50,
      },
    },
    l4: {
      paddingBottom: 20,
      height: "30vh",
      overflowY: "auto",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    status: {
      marginLeft: "16px",
      marginTop: 6,
      [theme.breakpoints.down("xs")]: {
        marginBottom: 18,
        marginLeft: 8,
      },
    },
    divIcon: {
      backgroundColor: "#e2f4fb",
      borderRadius: "8px",
      height: "3.1em",
    },
    reference: {
      fontSize: "16px",
      fontWeight: "bold",
      fontStretch: "normal",
      letterSpacing: "normal",
      color: "#616161",
      [theme.breakpoints.down("xs")]: {
        fontSize: "14px",
        fontWeight: "bold",
        fontStretch: "normal",
        letterSpacing: "normal",
        color: "#616161",
      },
    },
    createdAt: {
      fontSize: "12px",
      fontWeight: 500,
      fontStretch: "normal",
      letterSpacing: "normal",
      color: "#616161",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
        fontWeight: 500,
        fontStretch: "normal",
        letterSpacing: "normal",
        color: "#616161",
      },
    },
    referenceStyle: {
      display: "flex"
    }
  })
);
